export const ContactVariables = {
  zutoContactNumber: '01625619944',
  zutoInfoEmail: 'info@zuto.com',
  whatsappNumber: '447418303177'
}
